import { css, cx } from "@emotion/css"

import Image from "@p-ban/common/src/components/html/Image"

import COLOR_CODE from "../../../../constant/color"

type Props = {
  checked: boolean
  disabled: boolean
  isHovered: boolean
  isFocusVisible: boolean
  prefixNode?: React.ReactNode
  prefixImageSrc?: string
  suffixImageSrc?: string
  children: React.ReactNode
}

const InputBox = ({
  children,
  checked,
  disabled,
  isHovered,
  isFocusVisible,
  prefixNode,
  prefixImageSrc,
  suffixImageSrc,
}: Props) => {
  return (
    <div
      className={cx(
        styles.default,
        checked && styles.checked,
        !checked && !disabled && isHovered && styles.hover,
        isFocusVisible && styles.focus,
      )}
    >
      {prefixImageSrc && <Image src={prefixImageSrc} alt="" />}
      {prefixNode}
      <span className={styles.label}>{children}</span>
      {suffixImageSrc && <Image src={suffixImageSrc} alt="" />}
    </div>
  )
}

export default InputBox

const styles = {
  label: css`
    padding: 8px 0;
    white-space: pre-line;
  `,
  default: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 34px;
    padding: 0 12px;

    font-size: 13px;
    line-height: 16px;

    color: #9fa6ad;

    text-align: center;

    border: 1px solid #cdd7e1;
    border-radius: 4px;
  `,
  checked: css`
    color: ${COLOR_CODE.WHITE};
    background-color: #16a34a;
    border: 1px solid #16a34a;
  `,
  hover: css`
    color: ${COLOR_CODE.LIGHT_BLACK};
    background-color: ${COLOR_CODE.LIGHT_GREEN};
  `,
  focus: css`
    box-shadow: 0 0 0 2px ${COLOR_CODE.FOCUS_GRAY};
  `,
}
